# Route: /admin/users
# Tenant admin: list realm users from Keycloak

page-admin-user-list:
  type: Page
  archetype: list
  meta:
    title: $t.admin.users.meta_title
    auth: required
  data:
    users:
      model: UserSummary[]
      refresh: on_mount
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
    responsive:
      sm:
        padding: $spacing.sm
        padding_inline: $spacing.sm
        gap: $spacing.md
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - user-list-header
    - user-list-table

# ── Header ───────────────────────────────────────────────────────────────────

user-list-header:
  type: PageHeader
  title: $t.admin.users.title
  action_label: $t.admin.users.invite
  action_route: /admin/invitations

# ── User table ───────────────────────────────────────────────────────────────

user-list-table:
  type: Table
  bind:
    rows: users
  # M1 list-filter adoption (DEC-090) — opt-in client-side quick-filter:
  # case-insensitive substring over username + email across the loaded rows.
  filter:
    fields: [username, email]
    placeholder: $t.common.quick_filter
  a11y:
    label: $t.admin.users.table_label
  columns:
    - key: username
      label: $t.admin.users.col_username
      width: 2fr
    - key: email
      label: $t.admin.users.col_email
      width: 2fr
    - key: enabled
      label: $t.admin.users.col_status
      width: 1fr
  row_action:
    type: navigate
    route: /admin/users/:id
    params:
      id: $row.id
  empty: user-list-empty

user-list-empty:
  type: EmptyState
  content: $t.admin.users.empty
  body: $t.admin.users.empty_body
